import * as React from 'react';
import '../../../../../styles/PropertiesPage.css';
import Button from '../../../../common/form/Button';
import Modal from 'reactstrap/lib/Modal';
import ModalBody from 'reactstrap/lib/ModalBody';
import ModalFooter from 'reactstrap/lib/ModalFooter';
import { browserHistory } from '../../../../../utilities/history';
import { TourPage, tourSignupPath } from '../../signup/TourRouter';
import { Link } from 'react-router-dom';
import { FaqBasePath } from '../../ProspectRouteValues';
import { Property } from '../../../../../api/Property';
import { prospectLoggedIn } from '../../../../../utilities/identity';
const clearIcon = require('../../../../../images/close-menu.svg');
const logo = require('../../../../../images/logo-color.png');

export interface Props {
    property: Property | undefined;
    closeProperyDetail: () => void;
}

const PropertyDetailView = (props: Props) => {
    const navigateToTour = () => {
        if (props.property) {
            browserHistory.push(
                tourSignupPath(props.property.slug)(
                    prospectLoggedIn() ? TourPage.GuestCard : TourPage.Registration
                )
            );
        }
    };
    return (
        <Modal
            isOpen={props.property !== undefined}
            className="property-detail"
            toggle={props.closeProperyDetail}
        >
            {props.property ? (
                <>
                    {props.property.propertyImage && (
                        <img className="header-image" src={props.property.propertyImage} />
                    )}
                    <ModalBody className="information">
                        <>
                            <div className="property-information">
                                <div className="left">
                                    <div className="name">{props.property.name}</div>
                                    <div className="address">
                                        <div>{props.property.streetAddress}</div>
                                        <div>
                                            {`${props.property.city}  ${props.property.state}, ${props.property.zip}`}
                                        </div>
                                    </div>
                                </div>
                                <div className="icon-section">
                                    <div className="close-container">
                                        <img
                                            src={clearIcon}
                                            onClick={() => props.closeProperyDetail()}
                                        />
                                    </div>
                                    <div className="logo-icon">
                                        <img src={logo} />
                                    </div>
                                </div>
                            </div>
                            {props.property.faqsAreActive && (
                                <div className="pricing">
                                    <Link to={`${FaqBasePath}/${props.property.slug}`}>FAQs</Link>
                                </div>
                            )}
                        </>
                    </ModalBody>
                    <ModalFooter>
                        <div className="next-steps">
                            <Button
                                text="Schedule Tour"
                                onClick={navigateToTour}
                                addlClassName="btn-primary"
                                removeBoldFont={true}
                                suppressBottomMargin={true}
                            />
                        </div>
                    </ModalFooter>
                </>
            ) : null}
        </Modal>
    );
};

export default PropertyDetailView;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/public/properties/PropertyDetailView.tsx